import { useRouter } from "next/router";
import { Routes } from "~/routes";
import { LoadingBoundary } from "~/components/LoadingBoundary";
import { useUser } from "~/modules/user/hooks/useUser";

// // // //
/**
 * RedirectToLoginWhenNotAuthenticated
 * Redirects the user to the login page when they're not authenticated
 */

export function RedirectToLoginWhenNotAuthenticated(props: {
    children: React.ReactNode;
    redirectTo?: string;
}) {
    const { children, redirectTo = Routes.login } = props;
    const router = useRouter();
    const { isLoggedIn, loading } = useUser();

    const loginFlowComplete = loading === false;

    // If not logged in, redirect to redirectTo page (Login page by default)
    if (loginFlowComplete && !isLoggedIn) {
        router.push(redirectTo);
    }

    // Otherwise, render props.children
    // LoadingBoundary will stay rendered until redirect has resolved
    return (
        <LoadingBoundary
            className="h-full"
            loading={!loginFlowComplete || !isLoggedIn}
        >
            {children}
        </LoadingBoundary>
    );
}
